import script from "./Photography.vue?vue&type=script&setup=true&lang=js"
export * from "./Photography.vue?vue&type=script&setup=true&lang=js"

import "./Photography.vue?vue&type=style&index=0&id=b5f1b6de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5f1b6de"]])

export default __exports__